<div class="main h-100 w-100" style="background-color: #F9F9F9;">
  <!-- <div style="z-index : 10;position: absolute;" class="col-12">
    <img src='../../../assets/images/carouselbg.png' alt="login" class="login" height="635" style="width: inherit;filter: blur(16px);
        -webkit-filter: blur(16px);" width="1340">
  </div> -->
  <div class="col-12 reset-form">
    <div class="card" style="width: 30rem;height: fit-content;">
      <form [formGroup]="passwordForm" (ngSubmit)="savePassowrd()">
        <div class="card-body">
          <h5 class="text-center">Reset Password</h5>
          <label for="oldPassword">Old Password </label>

          <div style="position:relative;margin-top: -19px;">
            <span style="padding-left: 13px;">
              <i style="color:#BFBFBF;font-size:20px;position: absolute;
                top: 44px;" class="fa fa-lg fa-lock"></i>
              <input id="oldPassword" [type]="showOldPassword ? 'text' : 'password'" style="padding-left: 46px;"
                placeholder="Enter Old Password" formControlName="oldPassword" class="form-control mt-2">
              <span class="showIcon">
                <i class="fa fa-eye" *ngIf="showOldPassword" (click)="passwordOld()" style="color:#ED1556"></i>
                <i class="fa fa-eye-slash" *ngIf="!showOldPassword" (click)="passwordOld()" style="color:#ED1556"></i>
              </span>
            </span>
          </div>
          <label for="password" class="mt-4">New Password </label>

          <div style="position:relative;margin-top: -19px;">
            <span style="padding-left: 13px;">
              <i style="color:#BFBFBF;font-size:20px;position: absolute;
              top: 44px;" class="fa fa-lg fa-lock"></i>
              <input id="password" [type]="shows ? 'text' : 'password'" style="padding-left: 46px;"
                placeholder="Enter Password" formControlName="newPassword" class="form-control mt-2">
              <span class="showIcon">
                <i class="fa fa-eye" *ngIf="shows" (click)="password()" style="color:#ED1556"></i>
                <i class="fa fa-eye-slash" *ngIf="!shows" (click)="password()" style="color:#ED1556"></i>
              </span>
            </span>
          </div>
          <div *ngIf="passwordForm.controls.newPassword.status != 'VALID' && passwordForm.value.newPassword.length >= 1"
            class="passPatternErrMsg">
            <ul>
              <li>Password must contain a minimum of eight characters</li>
              <li>At least one letter</li>
              <li>At least one number</li>
              <li>At least one special character</li>
            </ul>
          </div>
          <label for="confirmPassword"
            [ngClass]="passwordForm.controls.newPassword.status != 'VALID' && passwordForm.value.newPassword.length >= 1 ? 'mt-1' : 'mt-4'">
            Confirm Password
          </label>
          <div style="position:relative;margin-top: -19px;">
            <span style="padding-left: 13px;">
              <i style="color:#BFBFBF;font-size:20px;position: absolute;
              top: 44px;" class="fa fa-lg fa-lock"></i>
              <input id="confirmPassword" [type]="showBottom ? 'text' : 'password'" style="padding-left: 46px;"
                placeholder="Re-Enter Password" formControlName="confirmPassword" class="form-control mt-2">
              <span class="showIcon">
                <i class="fa fa-eye" *ngIf="showBottom" (click)="passwordBottom()" style="color:#ED1556"></i>
                <i class="fa fa-eye-slash" *ngIf="!showBottom" (click)="passwordBottom()" style="color:#ED1556"></i>
              </span>
            </span>
          </div>
          <div *ngIf="passwordForm.hasError('passwordMismatch') && passwordForm.value.confirmPassword.length >= 1"
            class="passNotMatch">Password don't match. Try again.</div>
        </div>
        <div class="text-center mb-3">
          <input type="submit" class="btn btn-primary" style="background-color: #ED1556;color:white;"
            [disabled]="!passwordForm.valid" />
        </div>
      </form>
    </div>

  </div>

</div>